import React from 'react';

const Column = ({ title, children, rightBorder = true }) => {
  return (
    <section style={{
      flex: 1,
      padding: 16,
      borderRight: rightBorder ? '1px solid #eee' : 'none',
      background: '#fff'
    }}>
      {title && <h4 style={{ marginTop: 0, marginBottom: 12, opacity: .7 }}>{title}</h4>}
      {children}
    </section>
  );
};

export default Column;
